module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-results-photo-01.jpg?h=6190a7d3d0ac118ef39faff2c771ea80";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-results-photo-01.jpg
// module id = 2098
// module chunks = 12 15